var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.901 1h3.68l-8.04 9.319L24 23h-7.406l-5.8-7.691L4.155 23H.474l8.6-9.968L0 1h7.594l5.243 7.03L18.901 1ZM17.61 20.766h2.039L6.486 3.116H4.298l13.312 17.65Z",
    fill: "currentColor"
  })));
};
export default SvgTwitter;